<template>
  <div class="loadPage">
    <div class="content">
      <div class="logo-area">
        <i class="logo"></i>
        搭个圈
      </div>
      <div class="title-area">
        <div class="bg"></div>
        <p>线下真实场景拼玩</p>
        <p>社交平台</p>
      </div>
      <div class="img-area">
        <img :src="imgBg" />
      </div>
      <div class="btn-area" @click="load">立即下载</div>
    </div>
  </div>
</template>

<script>
import MobileDetect from 'mobile-detect';

export default {
  data() {
    return {
      imgBg: require("../../assets/images/loadPageImg.png"),
      md: new MobileDetect(window.navigator.userAgent),
    }
  },
  methods: {
    load() {
      // alert(this.md.os())
      if (this.md.os() === 'iOS') {
          window.location.href = 'https://apps.apple.com/us/app/%E6%90%AD%E4%B8%AA%E5%9C%88/id6479342543'; // 替换成你的iOS App的App Store链接
      } else if (this.md.os() === 'AndroidOS') {
          window.location.href = 'https://share.hzdagequan.com/downloads/dgq-release.apk'; // 替换成你的Android App的应用商店链接
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.loadPage {
  position: relative;
  width: 100%;
  height: 100%;
  background: url(../../assets/images/loadPageBg.png) no-repeat;
  background-size: 100% 100%;
  .logo-area {
    padding: 30px 30px;
    display: flex;
    align-items: center;
    font-weight: 700;
    font-size: 20px;
    color: #180d24;
    .logo {
      display: inline-block;
      margin-left: 18px;
      width: 36px;
      height: 36px;
      background: url(../../assets/images/loadPageLogo.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .title-area {
    position: relative;
    margin: 1rem 0;
    font-weight: 700;
    font-size: 32px;
    color: #180d24;
    line-height: 32px;
    text-align: center;
    letter-spacing: 2px;
    .bg {
      position: relative;
      left: 50%;
      top: 54px;
      margin-left: -68px;
      width: 134px;
      height: 12px;
      background: #d1bbff;
      border-radius: 0px 0px 0px 0px;
      z-index: 1;
    }
    p {
      position: relative;
      width: 100%;
      margin: 1.5rem 0;
      z-index: 2;
    }
  }
  .img-area {
    margin: 1rem auto;
    img {
      width: 100%;
    }
  }
  .btn-area {
    margin: 3rem auto 0;
    width: 160px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    background: url(../../assets/images/loadPageIcon.png) no-repeat;
    background-size: 100% 100%;
    font-size: 18px;
    color: #ffffff;
  }
}
</style>